export default {
    // Endpoints
    loginEndpoint: '/auth/login',
    // refreshEndpoint: '/jwt/refresh-token',
    // logoutEndpoint: '/jwt/logout',
  
    Endpoint: '/',
    EndpointInternal: '/',
    
    // This will be prefixed in authorization header with token
    // e.g. Authorization: Bearer <token>
    tokenType: 'Bearer',
  
    // Value of this property will be used as key to store JWT token in storage
    storageTokenKeyName: 'smileAccessToken',
    // storageRefreshTokenKeyName: 'refreshToken',
  }
  